module.exports = __webpack_public_path__ + "assets/img/prize-5.e25cf1f7.jpg";